import { Calendar } from 'primeng/calendar';

const bindDocumentResizeListener = Calendar.prototype.bindDocumentResizeListener;

Calendar.prototype.bindDocumentResizeListener = function (this: Calendar) {
  const calendar = this as any;
  if (!calendar.window) {
    calendar.window = this.document?.defaultView ?? window;
  }
  bindDocumentResizeListener.apply(this);
};

const ngOnInit = Calendar.prototype.ngOnInit;

Calendar.prototype.ngOnInit = function (this: Calendar) {
  this.todayButtonStyleClass ??= 'p-button-text';
  this.clearButtonStyleClass ??= 'p-button-text';
  ngOnInit.apply(this);
};
